/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import './styles.scss'

const isMobile = window.innerWidth < 320

export function TableSymptom() {
  return (
    <div className='index' id='tableSymptom'>
      <div className='tableContainer'>
        <table className='ui small very compact unstackable table'>
          <thead>
            <tr className='bottom aligned'>
              <th className='two wide'>Symptome</th>
              <th className='four wide'>Pollen&shy;allergie</th>
              <th className='four wide'>Covid-19</th>
            </tr>
          </thead>
          <tbody>
            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img
                    src={require('../../images/icon-halsschmerzen.svg')}
                  ></img>
                  <span>Juckreiz in Gaumen, Nase</span>
                </div>
              </td>
              <td className='often'>häufig</td>
              <td className='never'>nie</td>
            </tr>
            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img src={require('../../images/icon-augenjucken.svg')}></img>
                  <span>Juckende, brennende Augen</span>
                </div>
              </td>
              <td className='often'>häufig</td>
              <td className='never'>nie</td>
            </tr>

            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img src={require('../../images/icon-niesen.svg')}></img>
                  <span>Niesen</span>
                </div>
              </td>
              <td className='often'>häufig</td>
              <td className='rare'>selten</td>
            </tr>

            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img src={require('../../images/icon-schnupfen.svg')}></img>
                  <span>Schnupfen</span>
                </div>
              </td>
              <td className='often'>häufig</td>
              <td className='sometimes'>manchmal</td>
            </tr>

            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img src={require('../../images/icon-muedigkeit.svg')}></img>
                  <span>Müdigkeit</span>
                </div>
              </td>
              <td className='sometimes'>manchmal</td>
              <td className='sometimes'>manchmal</td>
            </tr>

            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img
                    src={require('../../images/icon-kopfschmerzen.svg')}
                  ></img>
                  <span>Kopfschmerzen</span>
                </div>
              </td>
              <td className='rare'>selten</td>
              <td className='sometimes'>manchmal</td>
            </tr>

            <tr className=''>
              <td>
                <div className='iconWrapper'>
                  <img
                    src={require('../../images/icon-trockener-husten.svg')}
                  ></img>
                  <span>Trockener Husten</span>
                </div>
              </td>
              <td className='rare'>
                <div className='wordContainer'>selten</div>
              </td>
              <td className='often'>
                <div className='wordContainer'>häufig</div>
              </td>
            </tr>

            <tr className=''>
              <td>
                <div className='iconWrapper'>
                  <img src={require('../../images/icon-atemnot.svg')}></img>
                  <span>Atemnot</span>
                </div>
              </td>
              <td className='never'>nie</td>
              <td className='sometimes'>manchmal</td>
            </tr>
            <tr className=''>
              <td>
                {' '}
                <div className='iconWrapper'>
                  <img
                    src={require('../../images/icon-gliederschmerzen.svg')}
                  ></img>
                  <span>Glieder&shy;schmerzen</span>
                </div>
              </td>
              <td className='never'>nie</td>
              <td className='sometimes'>manchmal</td>
            </tr>
            <tr className=''>
              <td>
                <div className='iconWrapper'>
                  <img
                    src={require('../../images/icon-geschmacksverlust.svg')}
                  ></img>
                  <span>
                    Geruchs- oder{' '}
                    <span className={!isMobile ? 'noWordwrap' : ''}>
                      Geschmacks&shy;verlust
                    </span>
                  </span>
                </div>
              </td>
              <td className='never'>nie</td>
              <td className='often'>häufig</td>
            </tr>

            {/* <tr className=''>
                <td>
                  {' '}
                  <div className='iconWrapper'>
                    <img src={require('../../images/icon-erbrechen.svg')}></img>
                    <span>Übelkeit oder Erbrechen</span>
                  </div>
                </td>
                <td className='sometimes'>manchmal</td>
                <td className='sometimes'>manchmal (Kinder)</td>
              </tr> */}
            <tr className=''>
              <td>
                <div className='iconWrapper'>
                  <img src={require('../../images/icon-fieber.svg')}></img>
                  <span>Fieber</span>
                </div>
              </td>
              <td className='never'>nie</td>
              <td className='often'>häufig</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='foot'>
        <p className='source'>Quellen: Allergiezentrum Schweiz, WHO, CDC</p>
      </div>
    </div>
  )
}
